import moment, { DATE_FORMAT } from '@/utils/moment-wrapper';

function buildCompletedEverFilterString ({ filterIndex }) {
    return `!isNull(lastCompletedAt${filterIndex})&&lastCompletedAt${filterIndex}!=0`;
}

function buildNotCompletedEverFilterString ({ filterIndex }) {
    return `lastCompletedAt${filterIndex}==0`;
}

function buildStartedEverFilterString ({ filterIndex }) {
    return `startedAt${filterIndex}>0`;
}

function buildNotStartedEverFilterString ({ filterIndex }) {
    return `isNull(startedAt${filterIndex})`;
}

function buildCompletedSinceFilterString ({ value, filterIndex }) {
    const date = moment(value, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);

    return `lastCompletedAt${filterIndex}>=date("${date}")`;
}

function buildNotCompletedSinceFilterString ({ value, filterIndex }) {
    const startedSinceFilter = buildStartedSinceFilterString({ filterIndex, value });

    return `startedAt${filterIndex}>lastCompletedAt${filterIndex}&&${startedSinceFilter}`;
}

function buildStartedSinceFilterString ({ value, filterIndex }) {
    const date = moment(value, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);

    return `startedAt${filterIndex}>=date("${date}")`;
}

function buildCompletedWithinLastFilterString ({ filterIndex, count, granularity }) {
    return `lastCompletedAt${filterIndex}>=dateAdd(startOfPeriod("daily",now()),-${count},"${granularity}")`;
}

function buildNotCompletedWithinLastFilterString ({ filterIndex, count, granularity }) {
    const startedWithinLastFilter = buildStartedWithinLastFilterString({ filterIndex, count, granularity });

    return `startedAt${filterIndex}>lastCompletedAt${filterIndex}&&${startedWithinLastFilter}`;
}

function buildStartedWithinLastFilterString ({ filterIndex, count, granularity }) {
    return `startedAt${filterIndex}>=dateAdd(startOfPeriod("daily",now()),-${count},"${granularity}")`;
}

export function parseWorkflowProgressFilterPipeline ({ fact, used, ...params }) {
    let filterString;

    switch (fact) {
        case 'completed':
            filterString = buildCompletedEverFilterString(params);

            switch (used) {
                case 'since':
                    filterString += `&&${buildCompletedSinceFilterString(params)}`;
                    break;
                case 'withinLast': {
                    filterString += `&&${buildCompletedWithinLastFilterString(params)}`;
                    break;
                }
                // default 'ever'; nothing appended
            }
            break;
        case 'incomplete':
            filterString = buildStartedEverFilterString(params);
            switch (used) {
                case 'ever':
                    filterString += `&&${buildNotCompletedEverFilterString(params)}`;
                    break;
                case 'since':
                    filterString += `&&${buildNotCompletedSinceFilterString(params)}`;
                    break;
                case 'withinLast': {
                    filterString += `&&${buildNotCompletedWithinLastFilterString(params)}`;
                    break;
                }
            }
            break;
        case 'notstarted':
            filterString = buildNotStartedEverFilterString(params);

            switch (used) {
                case 'since':
                    filterString += `||!(${buildStartedSinceFilterString(params)})`;
                    break;
                case 'withinLast': {
                    filterString += `||!(${buildStartedWithinLastFilterString(params)})`;
                    break;
                }
                // default 'ever'; nothing appended
            }
            break;
    }

    return { filter: filterString };
}
